import Swiper, {
  Pagination,
  Scrollbar
} from 'swiper';

Swiper.use([Pagination, Scrollbar]);

(function () {
  const ScreenWidth = {
    LARGE: 1300,
    MEDIUM: 992,
    SMALL: 768,
  }

  const carouselComponent = {
    init: true,
    effect: 'coverflow',
    grabCursor: true,
    slidesPerView: 'auto',
    spaceBetween: 10,
    loop: false,
    freeMode: true,
    slidesOffsetAfter: 10,
    a11y: true,
    keyboardControl: true,
    coverflow: {
      rotate: 0,
      stretch: 0,
      depth: 0,
      modifier: 0,
      slideShadows: false,
    }
  }

  const scrollBarComponent = {
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
      hide: true,
    },
  }

  const paginationComponent = {
    autoHeight: true,
    a11y: true,
    keyboardControl: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    }
  }

  const paginationMultipleComponent = {
    utoHeight: true,
    a11y: true,
    keyboardControl: true,
    spaceBetween: 40,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      720: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      1200: {
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    },
    watchOverflow: true
  }

  if (document.querySelector('.jsSwiperWithPagination')) {
    const swiperWithPagination = new Swiper('.jsSwiperWithPagination', {
      ...paginationComponent
    })
  }

  if (document.querySelector('.jsSwiperMultiplePagination')) {
    new Swiper('.jsSwiperMultiplePagination', {
      ...paginationMultipleComponent
    })
  }

  if (document.querySelector('.jsSwiperCards')) {
    let cardSlider;
    const breakpoint = window.matchMedia(`(max-width: ${ScreenWidth.LARGE}px)`);

    const breakpointChecker = () => {
      if (breakpoint.matches) {
        cardSlider = new Swiper(`.jsSwiperCards`, {
          ...carouselComponent
        })
      } else {
        if (cardSlider !== undefined) {
          cardSlider.destroy(true, true);
        }
      }
    }

    breakpointChecker();
    breakpoint.addListener(breakpointChecker);
  }

  if (document.querySelector('.jsSwiperHeroCards')) {
    let cardSlider;
    const breakpoint = window.matchMedia(`(max-width: ${ScreenWidth.MEDIUM}px)`);

    const breakpointChecker = () => {
      if (breakpoint.matches) {
        cardSlider = new Swiper(`.jsSwiperHeroCards`, {
          ...carouselComponent
        })
      } else {
        if (cardSlider !== undefined) {
          cardSlider.destroy(true, true);
        }
      }
    }

    breakpointChecker();
    breakpoint.addListener(breakpointChecker);
  }

  if (document.querySelector('.jsSwiperText')) {
    let textSlider;
    const breakpoint = window.matchMedia(`(max-width: ${ScreenWidth.SMALL}px)`);

    const breakpointChecker = () => {
      if (breakpoint.matches) {
        textSlider = new Swiper(`.jsSwiperText`, {
          ...carouselComponent,
          ...scrollBarComponent
        })
      } else {
        if (textSlider !== undefined) {
          textSlider.destroy(true, true);
        }
      }
    }

    breakpointChecker();
    breakpoint.addListener(breakpointChecker)
  }
})()
